import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["borderRadius", "inline", "display"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaults = {
  borderRadius: 'max',
  inline: false
};
var useSkeletonLoader = function useSkeletonLoader(_ref) {
  var _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? defaults.borderRadius : _ref$borderRadius,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? defaults.inline : _ref$inline,
    display = _ref.display,
    rest = _objectWithoutProperties(_ref, _excluded);
  var htmlTag;
  var displayValue = display;
  if (inline) {
    var _displayValue;
    htmlTag = 'span';
    (_displayValue = displayValue) !== null && _displayValue !== void 0 ? _displayValue : displayValue = 'inline-block';
  }
  return {
    containerProps: _objectSpread(_objectSpread({
      height: '100%',
      borderRadius: borderRadius,
      display: displayValue
    }, rest), {}, {
      as: htmlTag,
      backgroundColor: 'base.inset',
      adsClass: ['pulse']
    }),
    childrenContainerProps: {
      as: htmlTag,
      visibility: 'hidden'
    }
  };
};

export { useSkeletonLoader };
//# sourceMappingURL=useSkeletonLoader.js.map
